import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignItems: 'center',
      display: 'flex',
      background: '#fff',
      flex: 1,
      gap: 32,
      height: 80,
    },
    menuItem: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      position: 'relative',

      '&:first-child': {
        marginInlineStart: 56,
      },

      '&:hover': {
        '& .NavDropdown': {
          display: 'flex',
        },

        '& $arrowIcon': {
          fill: '#000',
          marginBlockStart: 4,
          transform: 'rotate(180deg)',
        },

        '& $label': {
          color: '#000',
        },

        '& $icon': {
          fill: '#000',
        },
      },
    },

    label: {
      color: '#666',
      fontSize: 14,
      fontWeight: 600,
      marginInlineEnd: 8,
    },

    icon: {
      fill: '#666',
      height: 24,
      marginInlineEnd: 8,
      width: 24,
    },
    arrowIcon: {
      fill: 'var(--x-accent-1-1)',
    },
  }),
  { name: 'DesktopNav' },
);

export default useStyles;
